// Types
import Locale from '@/types/locale';
import { RiskProfileConfigRequirements } from '@/types/risk-profiles/risk-profiles';
import { RiskProfileRule } from '@/types/risk-profiles';

// Utils
import { getRiskProfileRuleTargets } from '@/utils/risk-profiles';
import { TargetData } from '../types/TargetData';

export const transformRequirementsToTargets = (requirements: RiskProfileConfigRequirements[], locale: Locale): TargetData[] =>
  requirements.flatMap((targets, index) =>
    targets.map(target => ({
      key: `req-${index}-${target.key}`,
      label: target.label[locale] || '',
      value: target.value[locale] || '',
    })),
  );

export const transformRulesToTargets = (rules: RiskProfileRule[]): TargetData[] =>
  rules.flatMap((rule, index) => {
    const targets = getRiskProfileRuleTargets(rule);
    return targets.map(target => ({
      key: `rule-${index}-${target.key}`,
      label: target.label,
      value: target.value,
    }));
  });
